export default __webpack_public_path__ + "static/main-4f5df6d67a777177e7f53d3db92bb428.jpg";